var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "labelDiv" },
    [
      _c("el-col", { staticClass: "inputDiv", attrs: { span: 12 } }, [
        _vm.pessoa && _vm.pessoa.tipo === "PF"
          ? _c(
              "div",
              { key: "pessoa-fisica" },
              [
                _c("app-display", {
                  attrs: { label: "CPF:", content: _vm.pessoa.pessoaFisica.cpf }
                }),
                _vm.pessoa.pessoaFisica.rg
                  ? _c("app-display", {
                      attrs: {
                        label: "RG:",
                        content: _vm.pessoa.pessoaFisica.rg
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.nacionalidade
                  ? _c("app-display", {
                      attrs: {
                        label: "Nacionalidade:",
                        content: _vm.getGentilico(
                          _vm.pessoa.pessoaFisica.nacionalidade
                        )
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.municipio ||
                _vm.pessoa.pessoaFisica.naturalidade
                  ? _c("app-display", {
                      attrs: {
                        label: "Naturalidade:",
                        content: _vm.getNaturalidade(_vm.pessoa.pessoaFisica)
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.profissao
                  ? _c("app-display", {
                      attrs: {
                        label: "Profissão:",
                        content: _vm.pessoa.pessoaFisica.profissao
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.pessoa && _vm.pessoa.tipo === "PJ"
          ? _c(
              "div",
              { key: "pessoa-juridica" },
              [
                _c("app-display", {
                  attrs: {
                    label: "CNPJ:",
                    content: _vm.pessoa.pessoaJuridica.cnpj
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: _vm.razaoSocialName,
                    content: _vm.pessoa.pessoaJuridica.razaoSocial
                  }
                }),
                !_vm.isConjuge
                  ? _c("app-display", {
                      attrs: { label: "E-mail:", content: _vm.pessoa.email }
                    })
                  : _vm._e(),
                _vm.pessoa.telefones.length > 0
                  ? _c("app-display-multiple", {
                      attrs: {
                        label: "Telefones:",
                        content: _vm.pessoa.telefones
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _c("el-col", { staticClass: "inputDiv", attrs: { span: 12 } }, [
        _vm.pessoa && _vm.pessoa.tipo === "PF"
          ? _c(
              "div",
              { key: "pessoa-fisica" },
              [
                _c("app-display", {
                  attrs: {
                    label: "Nome:",
                    content: _vm.pessoa.pessoaFisica.nome
                  }
                }),
                _vm.pessoa.pessoaFisica.orgaoExpedidor
                  ? _c("app-display", {
                      attrs: {
                        label: "Órgão expedidor:",
                        content: _vm.getOrgaoExpedidor(
                          _vm.pessoa.pessoaFisica.orgaoExpedidor
                        )
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.municipioEstadoNaturalidade
                  ? _c("app-display", {
                      attrs: {
                        label: "Naturalidade:",
                        content:
                          _vm.pessoa.pessoaFisica.municipioEstadoNaturalidade
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.nomeDaMae
                  ? _c("app-display", {
                      attrs: {
                        label: "Nome da Mãe:",
                        content: _vm.pessoa.pessoaFisica.nomeDaMae
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.telefones.length > 0
                  ? _c("app-display-multiple", {
                      attrs: {
                        label: "Telefones:",
                        content: _vm.pessoa.telefones
                      }
                    })
                  : _vm._e(),
                _vm.pessoa.pessoaFisica.estadoCivil
                  ? _c("app-display", {
                      attrs: {
                        label: "Estado civil:",
                        content: _vm.estadoCivilFormatado
                      }
                    })
                  : _vm._e(),
                _vm.data
                  ? _c("app-display", {
                      attrs: { label: "Data de nascimento:", content: _vm.data }
                    })
                  : _vm._e(),
                !_vm.isConjuge
                  ? _c("app-display", {
                      attrs: { label: "E-mail:", content: _vm.pessoa.email }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-496139c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496139c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/common/InformacoesPessoa.vue
// module id = null
// module chunks = 